import React from "react";
import { Box, Paper } from "@mui/material";
import "./CollapsibleHeader.css"; // Import the CSS file for styles

const CollapsibleHeader = ({ upperLayer, lowerLayer, isCollapsed }) => {
  return (
    <Box className="collapsible-container">
      {/* Upper Layer */}
      {!isCollapsed && (
        <Paper elevation={1} sx= {{ marginTop: '10px', border: '0.1px solid #ddd', borderRadius: '5px'}}>
          {upperLayer}
        </Paper>
      )}

      {/* Lower Layer */}
      <Box>{lowerLayer}</Box>
    </Box>
  );
};

export default CollapsibleHeader;